import { render } from "./Navbar2.vue?vue&type=template&id=ddf7b152&scoped=true"
import script from "./Navbar2.vue?vue&type=script&lang=js"
export * from "./Navbar2.vue?vue&type=script&lang=js"

import "./Navbar2.vue?vue&type=style&index=0&id=ddf7b152&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddf7b152"]])

export default __exports__